import LegalShell from "./LegalShell";
import { useCookieConsent } from "../../context/CookieConsentContext";

function ManageButton() {
  const { openBanner } = useCookieConsent();
  return (
    <div style={{
      marginBottom: 32,
      padding: "24px 28px",
      borderRadius: 14,
      background: "var(--bg-secondary)",
      border: "1px solid var(--border-subtle)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 16,
    }}>
      <div>
        <div style={{ fontSize: 14, fontWeight: 600, color: "var(--text-primary)", marginBottom: 4 }}>Your cookie preferences</div>
        <div style={{ fontSize: 13, color: "var(--text-dim)" }}>Review or change which cookies Ateno may use on your device.</div>
      </div>
      <button
        onClick={openBanner}
        style={{
          padding: "10px 22px",
          borderRadius: 8,
          border: "none",
          background: "var(--text-primary)",
          color: "var(--bg-primary)",
          fontSize: 14,
          fontWeight: 600,
          cursor: "pointer",
          whiteSpace: "nowrap",
          transition: "opacity .15s",
        }}
        onMouseEnter={e => e.currentTarget.style.opacity = ".85"}
        onMouseLeave={e => e.currentTarget.style.opacity = "1"}
      >
        Update preferences
      </button>
    </div>
  );
}

export default function CookiePolicyPage() {
  return (
    <LegalShell title="Cookie Policy" date="September 24, 2026">
      <ManageButton />
      <div className="legal-callout"><p><strong>Summary:</strong> This website uses browser storage to remember your preferences and support account sign-in. You can review your optional analytics preference at any time.</p></div>
      <h2>1. Cookies and Browser Storage</h2>
      <p>Cookies and other browser storage can remember information between visits. This policy covers the storage used by the Ateno website.</p>
      <h2>2. Storage Used by This Website</h2>
      <ul>
        <li><strong>Consent preferences</strong> — We save your choices in local storage and send a consent record to our server so they can be remembered.</li>
        <li><strong>Theme preference</strong> — We store your light, dark, or system-theme choice in local storage.</li>
        <li><strong>Authentication</strong> — Firebase Authentication supports account sign-in and may store authentication state in your browser.</li>
      </ul>
      <p>Local preference records remain until they are replaced or you clear the site's browser storage.</p>
      <h2>3. Optional Analytics</h2>
      <p>The preferences panel records whether you allow optional analytics. The current website does not load an optional analytics tracker. Saving an analytics preference does not itself enable one.</p>
      <h2>4. Third-Party Services</h2>
      <p>Account sign-in uses Firebase Authentication and, if you choose it, Google sign-in. External sites reached through links have their own storage and privacy practices.</p>
      <h2>5. Managing Your Preferences</h2>
      <p>Use “Update preferences” above to review your analytics choice. Essential storage cannot be switched off through that panel. You can also clear or block site storage in your browser settings.</p>
      <p>Clearing or blocking browser storage may sign you out or prevent your preferences from being remembered.</p>
      <h2>6. Changes to This Policy</h2>
      <p>We will update this policy and its date when the website's storage practices change.</p>
      <h2>7. Contact</h2>
      <div className="legal-callout"><p>Ateno Inc. · Privacy Team · <a href="mailto:privacy@ateno.co">privacy@ateno.co</a></p></div>
    </LegalShell>
  );
}
